<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="pt-40 px-4 text-center sm:block sm:p-0">
      <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
      -->
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-black opacity-75"></div>
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span
      >&#8203;
      <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div
        class="inline-block align-bottom overflow-hidden transform transition-all relative sm:align-middle sm:max-w-lg sm:w-ful"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div class="flex flex-col items-center">
          <button
            class="text-sm text-white px-3 py-1 mb-4 rounded-lg gradient lg:opacity-25 lg:hover:opacity-100 lg:transition lg:duration-500 lg:ease-in-out"
            @click="$emit('close-modal')"
          >
            back to moods
          </button>
          <img
            class="size rounded-lg mb-2"
            :src="require(`../assets/mood-gifs/${mood.image}`)"
          />
        </div>
        <iframe
          width="97%"
          height="20"
          scrolling="no"
          frameborder="no"
          allow="autoplay"
          :src="`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/${mood.playlistID}&color=%2384847c&inverse=false&auto_play=true&show_user=true`"
        ></iframe>
        <div
          style="
            font-size: 10px;
            color: #cccccc;
            line-break: anywhere;
            word-break: normal;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: Interstate, Lucida Grande, Lucida Sans Unicode,
              Lucida Sans, Garuda, Verdana, Tahoma, sans-serif;
            font-weight: 100;
          "
        ></div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Modal",
  props: ["mood"],
};
</script>

<style scoped>
.size {
  width: 500px;
}

button:focus {
  outline: 0;
}

.gradient {
  background-image: linear-gradient(
    225deg,
    #ff3cac 0%,
    #784ba0 50%,
    #2b86c5 100%
  );
}

@media only screen and (max-width: 600px) {
  .size {
  }
}
</style>